import { combineReducers } from 'redux';

import medicationDetails from './medicationDetails/slice';
import medicationSearch from './medicationSearch/slice';
import userEnteredMedication from './userEnteredMedication/slice';

const medicationsReducer = combineReducers({
  medicationDetails,
  medicationSearch,
  userEnteredMedication,
});

export default medicationsReducer;
